export function formatThemeInspirationsPriceRange(theme) {
  if (!theme?.inspirations?.length) {
    return theme.priceDifferenceAdvertised;
  }

  // Map inspiration prices to array of {formattedPrice, numericPrice}
  const inspirationPrices = theme.inspirations
    .filter((inspiration) => inspiration.advertisedPrice)
    .map((inspiration) => {
      const formattedPrice = inspiration.advertisedPrice.replace(/\+/g, '');
      const numericPrice = parseFloat(formattedPrice.replace(/[^0-9.-]+/g, ''));
      return {formattedPrice, numericPrice};
    })
    .filter((obj) => !isNaN(obj.numericPrice));

  if (!inspirationPrices.length) {
    return '';
  }

  inspirationPrices.sort((a, b) => a.numericPrice - b.numericPrice);

  const minPrice = inspirationPrices[0].formattedPrice;
  const maxPrice = inspirationPrices[inspirationPrices.length - 1].formattedPrice;

  if (minPrice === maxPrice) {
    return `+${minPrice}`;
  }
  return `+${minPrice} - ${maxPrice}`;
}
